(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var isMobile = window.innerWidth <= 480;
    
    // Force video autoplay for all videos
    function forceVideoPlay() {
      var videos = document.querySelectorAll('.reel-slider video');
      videos.forEach(function(video, index) {
        video.muted = true; // Ensure muted for autoplay
        video.playsInline = true;
        
        // Try to play immediately
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(function() {
            console.log('Video', index, 'started playing');
          }).catch(function(error) {
            console.log('Autoplay failed for video', index, ':', error);
            // Try again after a short delay
            setTimeout(function() {
              video.play().catch(e => console.log('Retry failed:', e));
            }, 100);
          });
        }
      });
    }
    
    // Initial video play attempt
    setTimeout(forceVideoPlay, 500);
    
    // Use Flickity for desktop with single row
    if (!isMobile && typeof Flickity !== 'undefined') {
      var slider = document.querySelector(".reel-slider");
      if (slider) {
        var flickityOptions = {
          cellAlign: "left",
          wrapAround: true,
          contain: true,
          resize: true,
          pageDots: true,
          prevNextButtons: false,
          friction: 0.8,
          selectedAttraction: 0.2,
          draggable: true,
          groupCells: 1, // Show one video at a time but allow scrolling
          freeScroll: true, // Allow free scrolling
          freeScrollFriction: 0.03
        };

        var flkty = new Flickity(slider, flickityOptions);

        // Force video play after Flickity initialization
        flkty.on('ready', function() {
          setTimeout(forceVideoPlay, 200);
        });

        // Play videos when they come into view
        flkty.on('change', function() {
          setTimeout(forceVideoPlay, 100);
        });

        // Custom navigation buttons
        var prevButton = document.querySelector(".custom-prev-button");
        var nextButton = document.querySelector(".custom-next-button");
        
        if (prevButton) {
          prevButton.addEventListener("click", function () {
            flkty.previous();
          });
        }

        if (nextButton) {
          nextButton.addEventListener("click", function () {
            flkty.next();
          });
        }

        // Handle resize
        window.addEventListener('resize', function() {
          var newIsMobile = window.innerWidth <= 480;
          if (newIsMobile && flkty) {
            flkty.destroy();
          }
        });
      }
    } else if (!isMobile) {
      // Fallback for desktop without Flickity - use native scroll
      console.log('Using native scroll for desktop');
      setTimeout(forceVideoPlay, 200);
    }

    // Handle video intersection for autoplay (when videos come into view)
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.paused) {
              video.play().catch(e => console.log('Intersection play failed:', e));
            }
          }
        });
      }, {
        threshold: 0.5
      });

      // Observe all videos
      document.querySelectorAll('.reel-slider video').forEach(function(video) {
        observer.observe(video);
      });
    }

    // Add to Cart Functionality
    window.addToCart = function(cartUrl, blockId) {
      console.log('Add to Cart clicked for block:', blockId, 'Product URL:', cartUrl);
      if (!cartUrl || cartUrl === '#') {
        console.error('No Product URL provided for block:', blockId);
        return;
      }
      try {
        window.location.href = cartUrl;
      } catch (error) {
        console.error('Error redirecting to product page:', error);
      }
    };

    // User interaction to enable autoplay (for browsers that require it)
    document.addEventListener('click', function() {
      setTimeout(forceVideoPlay, 50);
    }, { once: true });

    document.addEventListener('scroll', function() {
      setTimeout(forceVideoPlay, 50);
    }, { once: true });

    // Debug
    console.log('Mobile mode:', isMobile);
    console.log('Videos found:', document.querySelectorAll('.reel-slider video').length);
  });

  } catch(e) { console.error(e); }
})();
})();
